import { computed } from "vue";
import { storeToRefs } from "pinia";

import { useAccountsStore } from "@stores/accounts";
import { useTemplatesStore } from "@/stores/mailing/templates";
import { useCurrentUserStore } from "@/stores/currentUser";
import { createFilters } from "@/utils/composables/filters/createFilters";

export const useTemplatesFilters = () => {
  const accountsStore = useAccountsStore();
  const templatesStore = useTemplatesStore();
  const currentUserStore = useCurrentUserStore();

  const { accounts } = storeToRefs(accountsStore);
  const { activeFilter, accountsFilter } = storeToRefs(templatesStore);
  const { clearFilters, getTemplates } = templatesStore;
  const { isAdmin } = storeToRefs(currentUserStore);

  const accountOptions = computed(() => accounts.value?.map(({ name, id }) => ({ label: name, value: id })) || []);

  return createFilters({
    filters: [
      {
        id: "active",
        label: "Status",
        options: [
          { label: "Active", value: true },
          { label: "Inactive", value: false },
        ],
        model: activeFilter,
      },
      {
        id: "accounts",
        label: "Account",
        hasSearch: true,
        options: accountOptions,
        model: accountsFilter,
        when: () => isAdmin.value || accounts.value.length > 1,
      },
    ],
    search: getTemplates,
    clear: clearFilters,
  });
};
